// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2745d7c7","644":"45b5001e","667":"1e0bf19c"}[chunkId] + ".chunk.js";
};